/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttributionSummaryResponseFromJSON, CampaignListResponseFromJSON, CampaignResponseFromJSON, CancelCampaignResponseFromJSON, ClientFailuresRecentResponseFromJSON, ClientFailuresSummaryResponseFromJSON, ContactSubmissionsRecentResponseFromJSON, CorrectRegistrationCountryRequestToJSON, CreateCampaignRequestToJSON, CreatePromptRequestToJSON, DailyMetricsFreshnessResponseFromJSON, DeliveriesResponseFromJSON, DispatchCampaignResponseFromJSON, DmarcSummaryResponseFromJSON, EmailQuotaStatusFromJSON, FirstPaymentCohortsResponseFromJSON, FunnelMetricsResponseFromJSON, GiftRequestToJSON, InstallVisibilityResponseFromJSON, MailTriageListResponseFromJSON, OverviewMetricsResponseFromJSON, PluginDriftRecentResponseFromJSON, PluginFailuresRecentResponseFromJSON, PluginFailuresSummaryResponseFromJSON, PreAuthFunnelResponseFromJSON, QuotaExceededHitsResponseFromJSON, RecentVisitsResponseFromJSON, RecordingCapHitsResponseFromJSON, RecordingDurationResponseFromJSON, SendTestResponseFromJSON, SuccessRateByVersionResponseFromJSON, UnitEconomicsResponseFromJSON, UpdatePromptRequestToJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class AdminApi extends runtime.BaseAPI {
    /**
     * Cancel a campaign.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     dict with status.  Raises:     HTTPException: 404 if campaign not found, 409 if already completed.
     * Cancel Campaign
     */
    async cancelCampaignV1AdminCampaignsCampaignIdCancelPostRaw(requestParameters, initOverrides) {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError('campaignId', 'Required parameter "campaignId" was null or undefined when calling cancelCampaignV1AdminCampaignsCampaignIdCancelPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns/{campaign_id}/cancel`;
        urlPath = urlPath.replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters['campaignId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CancelCampaignResponseFromJSON(jsonValue));
    }
    /**
     * Cancel a campaign.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     dict with status.  Raises:     HTTPException: 404 if campaign not found, 409 if already completed.
     * Cancel Campaign
     */
    async cancelCampaignV1AdminCampaignsCampaignIdCancelPost(requestParameters, initOverrides) {
        const response = await this.cancelCampaignV1AdminCampaignsCampaignIdCancelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Rectify a user\'s registration_country (RODO art.  16, checkpoint W13).  `registration_country` is otherwise write-once at signup (`src.db.models.user.User.create`) — this is the one sanctioned correction door, for the exact failure mode the checkpoint names (VPN, business travel, a cross-border carrier IP misreading the GeoIP lookup). Requires the `admin` role, not just `viewer` — this mutates OSS place-of-supply evidence, not a read.  Args:     uid: User UID.     request: New country code + mandatory reason.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status, uid, old_country, new_country.
     * Correct Registration Country
     */
    async correctRegistrationCountryV1AdminUsersUidCorrectRegistrationCountryPostRaw(requestParameters, initOverrides) {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError('uid', 'Required parameter "uid" was null or undefined when calling correctRegistrationCountryV1AdminUsersUidCorrectRegistrationCountryPost().');
        }
        if (requestParameters['correctRegistrationCountryRequest'] == null) {
            throw new runtime.RequiredError('correctRegistrationCountryRequest', 'Required parameter "correctRegistrationCountryRequest" was null or undefined when calling correctRegistrationCountryV1AdminUsersUidCorrectRegistrationCountryPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/users/{uid}/correct-registration-country`;
        urlPath = urlPath.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters['uid'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CorrectRegistrationCountryRequestToJSON(requestParameters['correctRegistrationCountryRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Rectify a user\'s registration_country (RODO art.  16, checkpoint W13).  `registration_country` is otherwise write-once at signup (`src.db.models.user.User.create`) — this is the one sanctioned correction door, for the exact failure mode the checkpoint names (VPN, business travel, a cross-border carrier IP misreading the GeoIP lookup). Requires the `admin` role, not just `viewer` — this mutates OSS place-of-supply evidence, not a read.  Args:     uid: User UID.     request: New country code + mandatory reason.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status, uid, old_country, new_country.
     * Correct Registration Country
     */
    async correctRegistrationCountryV1AdminUsersUidCorrectRegistrationCountryPost(requestParameters, initOverrides) {
        const response = await this.correctRegistrationCountryV1AdminUsersUidCorrectRegistrationCountryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a campaign, or extend an existing one for the same document+version.  V2M-DEV-311: calling this again with the same ``template`` + ``document_version`` never creates a duplicate campaign -- it reuses the existing one and only queues recipients who weren\'t already queued for it. This is the intended way to run the \"iterative\" mass-notification flow (call again later to pick up new signups without disturbing anyone already queued).  Args:     request: Campaign creation data.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     CampaignResponse with created (or extended) campaign data.  Raises:     HTTPException: 422 if the audience query resolved to zero recipients         on first-ever creation (``EmailCampaignService.create_campaign``         -- a campaign that has nobody to send to must never report         success), or if a campaign already exists for this         ``document_version`` with different ``params``.
     * Create Campaign
     */
    async createCampaignV1AdminCampaignsPostRaw(requestParameters, initOverrides) {
        if (requestParameters['createCampaignRequest'] == null) {
            throw new runtime.RequiredError('createCampaignRequest', 'Required parameter "createCampaignRequest" was null or undefined when calling createCampaignV1AdminCampaignsPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCampaignRequestToJSON(requestParameters['createCampaignRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignResponseFromJSON(jsonValue));
    }
    /**
     * Create a campaign, or extend an existing one for the same document+version.  V2M-DEV-311: calling this again with the same ``template`` + ``document_version`` never creates a duplicate campaign -- it reuses the existing one and only queues recipients who weren\'t already queued for it. This is the intended way to run the \"iterative\" mass-notification flow (call again later to pick up new signups without disturbing anyone already queued).  Args:     request: Campaign creation data.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     CampaignResponse with created (or extended) campaign data.  Raises:     HTTPException: 422 if the audience query resolved to zero recipients         on first-ever creation (``EmailCampaignService.create_campaign``         -- a campaign that has nobody to send to must never report         success), or if a campaign already exists for this         ``document_version`` with different ``params``.
     * Create Campaign
     */
    async createCampaignV1AdminCampaignsPost(requestParameters, initOverrides) {
        const response = await this.createCampaignV1AdminCampaignsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new prompt.  Validates template variables and checks the 20-active-per-type limit. Cache is invalidated after creation.  Args:     request: Prompt creation data.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     Created prompt data.
     * Create Prompt
     */
    async createPromptV1AdminPromptsPostRaw(requestParameters, initOverrides) {
        if (requestParameters['createPromptRequest'] == null) {
            throw new runtime.RequiredError('createPromptRequest', 'Required parameter "createPromptRequest" was null or undefined when calling createPromptV1AdminPromptsPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/prompts`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePromptRequestToJSON(requestParameters['createPromptRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Create a new prompt.  Validates template variables and checks the 20-active-per-type limit. Cache is invalidated after creation.  Args:     request: Prompt creation data.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     Created prompt data.
     * Create Prompt
     */
    async createPromptV1AdminPromptsPost(requestParameters, initOverrides) {
        const response = await this.createPromptV1AdminPromptsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Disable a prompt (soft delete).  Sets status to \"disabled\". Raises 409 if last active of type.  Args:     prompt_id: Prompt document ID.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status.
     * Disable Prompt
     */
    async disablePromptV1AdminPromptsPromptIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['promptId'] == null) {
            throw new runtime.RequiredError('promptId', 'Required parameter "promptId" was null or undefined when calling disablePromptV1AdminPromptsPromptIdDelete().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/prompts/{prompt_id}`;
        urlPath = urlPath.replace(`{${"prompt_id"}}`, encodeURIComponent(String(requestParameters['promptId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Disable a prompt (soft delete).  Sets status to \"disabled\". Raises 409 if last active of type.  Args:     prompt_id: Prompt document ID.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status.
     * Disable Prompt
     */
    async disablePromptV1AdminPromptsPromptIdDelete(requestParameters, initOverrides) {
        const response = await this.disablePromptV1AdminPromptsPromptIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Dispatch campaign — enqueue Cloud Tasks for all pending recipients.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     DispatchCampaignResponse with the enqueued task count.  Raises:     HTTPException: 404 if campaign not found.
     * Dispatch Campaign
     */
    async dispatchCampaignV1AdminCampaignsCampaignIdDispatchPostRaw(requestParameters, initOverrides) {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError('campaignId', 'Required parameter "campaignId" was null or undefined when calling dispatchCampaignV1AdminCampaignsCampaignIdDispatchPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns/{campaign_id}/dispatch`;
        urlPath = urlPath.replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters['campaignId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DispatchCampaignResponseFromJSON(jsonValue));
    }
    /**
     * Dispatch campaign — enqueue Cloud Tasks for all pending recipients.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     DispatchCampaignResponse with the enqueued task count.  Raises:     HTTPException: 404 if campaign not found.
     * Dispatch Campaign
     */
    async dispatchCampaignV1AdminCampaignsCampaignIdDispatchPost(requestParameters, initOverrides) {
        const response = await this.dispatchCampaignV1AdminCampaignsCampaignIdDispatchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return an aggregated attribution snapshot for the admin dashboard.  Aggregates the last `days` days of ``visits``, newly-created ``users`` (by ``acquisition.source`` / ``acquisition.attribution_method``), and ``purchases`` enriched with ``acquisition_snapshot``. Firestore has no group-by, so each collection is scanned (bounded, field-masked) and aggregated in Python — see ``attribution_stats_service`` for the read caps and the ``truncated`` semantics.  Args:     days: Window size in days (1-90, default 30).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     AttributionSummaryResponse: visits/users/conversions/funnel aggregates.
     * Get Attribution Summary
     */
    async getAttributionSummaryV1AdminAttributionSummaryGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/attribution/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AttributionSummaryResponseFromJSON(jsonValue));
    }
    /**
     * Return an aggregated attribution snapshot for the admin dashboard.  Aggregates the last `days` days of ``visits``, newly-created ``users`` (by ``acquisition.source`` / ``acquisition.attribution_method``), and ``purchases`` enriched with ``acquisition_snapshot``. Firestore has no group-by, so each collection is scanned (bounded, field-masked) and aggregated in Python — see ``attribution_stats_service`` for the read caps and the ``truncated`` semantics.  Args:     days: Window size in days (1-90, default 30).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     AttributionSummaryResponse: visits/users/conversions/funnel aggregates.
     * Get Attribution Summary
     */
    async getAttributionSummaryV1AdminAttributionSummaryGet(requestParameters = {}, initOverrides) {
        const response = await this.getAttributionSummaryV1AdminAttributionSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return current billing-pipeline health (bounded read-only check).  Runs the same three signals the scheduled job checks. Does not email.  Args:     _admin: Admin user info (viewer or admin).     db: Firestore client.  Returns:     dict with checkedAt, healthy, the metrics, and any alerts.
     * Get Billing Observability
     */
    async getBillingObservabilityV1AdminBillingObservabilityGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/billing/observability`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Return current billing-pipeline health (bounded read-only check).  Runs the same three signals the scheduled job checks. Does not email.  Args:     _admin: Admin user info (viewer or admin).     db: Firestore client.  Returns:     dict with checkedAt, healthy, the metrics, and any alerts.
     * Get Billing Observability
     */
    async getBillingObservabilityV1AdminBillingObservabilityGet(initOverrides) {
        const response = await this.getBillingObservabilityV1AdminBillingObservabilityGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get campaign details.  Args:     campaign_id: Campaign document ID.     admin: Admin user info.     service: EmailCampaignService.  Returns:     CampaignResponse with campaign data.  Raises:     HTTPException: 404 if campaign not found.
     * Get Campaign
     */
    async getCampaignV1AdminCampaignsCampaignIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError('campaignId', 'Required parameter "campaignId" was null or undefined when calling getCampaignV1AdminCampaignsCampaignIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns/{campaign_id}`;
        urlPath = urlPath.replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters['campaignId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignResponseFromJSON(jsonValue));
    }
    /**
     * Get campaign details.  Args:     campaign_id: Campaign document ID.     admin: Admin user info.     service: EmailCampaignService.  Returns:     CampaignResponse with campaign data.  Raises:     HTTPException: 404 if campaign not found.
     * Get Campaign
     */
    async getCampaignV1AdminCampaignsCampaignIdGet(requestParameters, initOverrides) {
        const response = await this.getCampaignV1AdminCampaignsCampaignIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return today\'s client-failure counts, total and broken down by error class.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ClientFailuresSummaryResponse: today\'s date, total count, per-error-class     breakdown (zeroed/empty when nothing failed today).
     * Get Client Failures Summary
     */
    async getClientFailuresSummaryV1AdminClientFailuresSummaryGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/client-failures/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ClientFailuresSummaryResponseFromJSON(jsonValue));
    }
    /**
     * Return today\'s client-failure counts, total and broken down by error class.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ClientFailuresSummaryResponse: today\'s date, total count, per-error-class     breakdown (zeroed/empty when nothing failed today).
     * Get Client Failures Summary
     */
    async getClientFailuresSummaryV1AdminClientFailuresSummaryGet(initOverrides) {
        const response = await this.getClientFailuresSummaryV1AdminClientFailuresSummaryGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Live \"is daily_metrics still being written\" check (V2M-DEV-080).  Runs the SAME deterministic freshness check the scheduled watchdog job runs (`src.jobs.daily_metrics_freshness_watchdog`), on demand and read-only (`notify=False` — an admin-panel poll must never itself trigger an ntfy page; only the scheduled job does that). This is the gap the 2026-08-03 prod-silence audit found: `daily_metrics` had not been written on production since 2026-07-26 with zero operator-visible signal anywhere — this endpoint is what makes that state visible in the panel the moment it recurs, independent of whether the Cloud Scheduler trigger for the watchdog job has been provisioned yet.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     DailyMetricsFreshnessResponse: hours since the last stamped write (or         null if unknown/none in the lookback window), and whether that         crosses the alert threshold right now.
     * Get Daily Metrics Freshness
     */
    async getDailyMetricsFreshnessV1AdminMetricsDailyMetricsFreshnessGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/daily-metrics-freshness`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DailyMetricsFreshnessResponseFromJSON(jsonValue));
    }
    /**
     * Live \"is daily_metrics still being written\" check (V2M-DEV-080).  Runs the SAME deterministic freshness check the scheduled watchdog job runs (`src.jobs.daily_metrics_freshness_watchdog`), on demand and read-only (`notify=False` — an admin-panel poll must never itself trigger an ntfy page; only the scheduled job does that). This is the gap the 2026-08-03 prod-silence audit found: `daily_metrics` had not been written on production since 2026-07-26 with zero operator-visible signal anywhere — this endpoint is what makes that state visible in the panel the moment it recurs, independent of whether the Cloud Scheduler trigger for the watchdog job has been provisioned yet.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     DailyMetricsFreshnessResponse: hours since the last stamped write (or         null if unknown/none in the lookback window), and whether that         crosses the alert threshold right now.
     * Get Daily Metrics Freshness
     */
    async getDailyMetricsFreshnessV1AdminMetricsDailyMetricsFreshnessGet(initOverrides) {
        const response = await this.getDailyMetricsFreshnessV1AdminMetricsDailyMetricsFreshnessGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get delivery records for a campaign.  Args:     campaign_id: Campaign document ID.     status: Optional status filter (pending/sent/failed).     limit: Max records to return (default 100).     admin: Admin user info.     service: EmailCampaignService.  Returns:     DeliveriesResponse with the matching delivery records.
     * Get Deliveries
     */
    async getDeliveriesV1AdminCampaignsCampaignIdDeliveriesGetRaw(requestParameters, initOverrides) {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError('campaignId', 'Required parameter "campaignId" was null or undefined when calling getDeliveriesV1AdminCampaignsCampaignIdDeliveriesGet().');
        }
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns/{campaign_id}/deliveries`;
        urlPath = urlPath.replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters['campaignId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveriesResponseFromJSON(jsonValue));
    }
    /**
     * Get delivery records for a campaign.  Args:     campaign_id: Campaign document ID.     status: Optional status filter (pending/sent/failed).     limit: Max records to return (default 100).     admin: Admin user info.     service: EmailCampaignService.  Returns:     DeliveriesResponse with the matching delivery records.
     * Get Deliveries
     */
    async getDeliveriesV1AdminCampaignsCampaignIdDeliveriesGet(requestParameters, initOverrides) {
        const response = await this.getDeliveriesV1AdminCampaignsCampaignIdDeliveriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Aggregate DMARC pass-rate metrics across all dmarc_report records.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     DmarcSummaryResponse: report_count, total_messages, spf/dkim pass     counts and rates (rates are 0.0 when there are no reports yet).
     * Get Dmarc Summary
     */
    async getDmarcSummaryV1AdminMailTriageDmarcSummaryGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/mail-triage/dmarc-summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DmarcSummaryResponseFromJSON(jsonValue));
    }
    /**
     * Aggregate DMARC pass-rate metrics across all dmarc_report records.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     DmarcSummaryResponse: report_count, total_messages, spf/dkim pass     counts and rates (rates are 0.0 when there are no reports yet).
     * Get Dmarc Summary
     */
    async getDmarcSummaryV1AdminMailTriageDmarcSummaryGet(initOverrides) {
        const response = await this.getDmarcSummaryV1AdminMailTriageDmarcSummaryGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * First-payment cohorts by calendar month, plus a recent-payers feed (V2M-DEV-012, signal #5).  All-time, no `days` window — see `FirstPaymentCohortsResponse` for why. Each non-synthetic user\'s EARLIEST `initial`/`one_time_purchase` `revenue_ledger` row (see `_first_payments_by_user`) is bucketed by its UTC calendar month into `cohorts` (sorted ascending, sparse — no zero-filled months) and also exposed individually, newest first and capped at `top`, as `recentFirstPayments`.  See `FirstPaymentCohortsResponse` docstring for the `writeFailuresTotal` rationale — it is read here from the same `revenue_ledger_write_failure_stats/current` doc `scripts/report_revenue_ledger.py` already reads, defaulting to 0 when that doc has never been written.  Args:     admin: Admin user info.     db: Firestore client.     top: Number of most-recent first-payments to return (1..200).  Returns:     FirstPaymentCohortsResponse.
     * Get First Payment Cohorts
     */
    async getFirstPaymentCohortsV1AdminMetricsFirstPaymentCohortsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['top'] != null) {
            queryParameters['top'] = requestParameters['top'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/first-payment-cohorts`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FirstPaymentCohortsResponseFromJSON(jsonValue));
    }
    /**
     * First-payment cohorts by calendar month, plus a recent-payers feed (V2M-DEV-012, signal #5).  All-time, no `days` window — see `FirstPaymentCohortsResponse` for why. Each non-synthetic user\'s EARLIEST `initial`/`one_time_purchase` `revenue_ledger` row (see `_first_payments_by_user`) is bucketed by its UTC calendar month into `cohorts` (sorted ascending, sparse — no zero-filled months) and also exposed individually, newest first and capped at `top`, as `recentFirstPayments`.  See `FirstPaymentCohortsResponse` docstring for the `writeFailuresTotal` rationale — it is read here from the same `revenue_ledger_write_failure_stats/current` doc `scripts/report_revenue_ledger.py` already reads, defaulting to 0 when that doc has never been written.  Args:     admin: Admin user info.     db: Firestore client.     top: Number of most-recent first-payments to return (1..200).  Returns:     FirstPaymentCohortsResponse.
     * Get First Payment Cohorts
     */
    async getFirstPaymentCohortsV1AdminMetricsFirstPaymentCohortsGet(requestParameters = {}, initOverrides) {
        const response = await this.getFirstPaymentCohortsV1AdminMetricsFirstPaymentCohortsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get acquisition-funnel stages E4 and E5 (V2M-DEV-011).  See `checkpoint/2026-07-29-lejek-akwizycji-definicja-i-metryki.md` for the 5-stage funnel definition. E1-E3 (ad impression -> install) are covered by `src.services.attribution_stats_service` + GA4, not this endpoint. This endpoint covers only the two stages that are entirely first-party (checkpoint §6: \"liczniki E4 i E5 są najtańsze ... i najbardziej diagnostyczne. Powstają pierwsze\").  E4 (`registeredUsers`/`activatedUsers`) is a real, queryable count over the `users` and `generations` collections, excluding `src.config.qa_fixture.SYNTHETIC_USER_IDS` the same way `get_overview_metrics` does. E5 (`paidUsers`/`conversionRate`) is the same kind of real, queryable count over `revenue_ledger` — see `FunnelStageE5` and `_paid_user_ids` docstrings for why it is now measurable and what it counts.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     FunnelMetricsResponse.
     * Get Funnel Metrics
     */
    async getFunnelMetricsV1AdminMetricsFunnelGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/funnel`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FunnelMetricsResponseFromJSON(jsonValue));
    }
    /**
     * Get acquisition-funnel stages E4 and E5 (V2M-DEV-011).  See `checkpoint/2026-07-29-lejek-akwizycji-definicja-i-metryki.md` for the 5-stage funnel definition. E1-E3 (ad impression -> install) are covered by `src.services.attribution_stats_service` + GA4, not this endpoint. This endpoint covers only the two stages that are entirely first-party (checkpoint §6: \"liczniki E4 i E5 są najtańsze ... i najbardziej diagnostyczne. Powstają pierwsze\").  E4 (`registeredUsers`/`activatedUsers`) is a real, queryable count over the `users` and `generations` collections, excluding `src.config.qa_fixture.SYNTHETIC_USER_IDS` the same way `get_overview_metrics` does. E5 (`paidUsers`/`conversionRate`) is the same kind of real, queryable count over `revenue_ledger` — see `FunnelStageE5` and `_paid_user_ids` docstrings for why it is now measurable and what it counts.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     FunnelMetricsResponse.
     * Get Funnel Metrics
     */
    async getFunnelMetricsV1AdminMetricsFunnelGet(initOverrides) {
        const response = await this.getFunnelMetricsV1AdminMetricsFunnelGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get paginated generation records with optional filters.  Args:     admin: Admin user info.     db: Firestore client.     limit: Maximum records to return.     prompt_id: Filter by prompt ID.     model_id: Filter by model ID.     status: Filter by status (completed, failed, stopped).  Returns:     dict with generations list.
     * Get Generation Records
     */
    async getGenerationRecordsV1AdminMetricsGenerationsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        if (requestParameters['modelId'] != null) {
            queryParameters['model_id'] = requestParameters['modelId'];
        }
        if (requestParameters['promptId'] != null) {
            queryParameters['prompt_id'] = requestParameters['promptId'];
        }
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/generations`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get paginated generation records with optional filters.  Args:     admin: Admin user info.     db: Firestore client.     limit: Maximum records to return.     prompt_id: Filter by prompt ID.     model_id: Filter by model ID.     status: Filter by status (completed, failed, stopped).  Returns:     dict with generations list.
     * Get Generation Records
     */
    async getGenerationRecordsV1AdminMetricsGenerationsGet(requestParameters = {}, initOverrides) {
        const response = await this.getGenerationRecordsV1AdminMetricsGenerationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the install-count mianownik from official store sources (V2M-DEV-493).  Investigated candidates for \"how many people installed the plugin\", each confirmed or rejected with evidence rather than assumed (see this endpoint\'s own module-level constants for the full reasoning):    - Chrome Web Store / Edge Add-ons: NO public machine API — panel-only,     not scraped. See `_CHROME_AND_EDGE_INSTALL_VISIBILITY_NOTE`.   - Firefox AMO: a real, public, unauthenticated v5 API — queried below.   - `extension_installed` Plausible event: exists, but is `\"analytics\"`-     class (consent-gated, fail-closed) and fires at the exact instant no     consent decision can exist yet — see `PreAuthFunnelResponse`\'s     `consentGatedEventNames` instead of duplicating that number here.   - Unique `device_id` count in `plugin_failure_reports`: an UPPER bound     on people (reinstalls/second browsers each mint a new id) that only     ever surfaces someone who hit a FAILURE — neither a floor nor a     ceiling on installs in general, and not backed by a query here since     it already exists as a first-party collection any admin can read     directly; adding a second, narrower re-derivation of it would invite     drift from whatever collection query is authoritative there.  Returns:     InstallVisibilityResponse.
     * Get Install Visibility
     */
    async getInstallVisibilityV1AdminMetricsInstallVisibilityGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/install-visibility`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => InstallVisibilityResponseFromJSON(jsonValue));
    }
    /**
     * Get the install-count mianownik from official store sources (V2M-DEV-493).  Investigated candidates for \"how many people installed the plugin\", each confirmed or rejected with evidence rather than assumed (see this endpoint\'s own module-level constants for the full reasoning):    - Chrome Web Store / Edge Add-ons: NO public machine API — panel-only,     not scraped. See `_CHROME_AND_EDGE_INSTALL_VISIBILITY_NOTE`.   - Firefox AMO: a real, public, unauthenticated v5 API — queried below.   - `extension_installed` Plausible event: exists, but is `\"analytics\"`-     class (consent-gated, fail-closed) and fires at the exact instant no     consent decision can exist yet — see `PreAuthFunnelResponse`\'s     `consentGatedEventNames` instead of duplicating that number here.   - Unique `device_id` count in `plugin_failure_reports`: an UPPER bound     on people (reinstalls/second browsers each mint a new id) that only     ever surfaces someone who hit a FAILURE — neither a floor nor a     ceiling on installs in general, and not backed by a query here since     it already exists as a first-party collection any admin can read     directly; adding a second, narrower re-derivation of it would invite     drift from whatever collection query is authoritative there.  Returns:     InstallVisibilityResponse.
     * Get Install Visibility
     */
    async getInstallVisibilityV1AdminMetricsInstallVisibilityGet(initOverrides) {
        const response = await this.getInstallVisibilityV1AdminMetricsInstallVisibilityGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get per-model metrics with avg latency and TTFT.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with models list including computed metrics.
     * Get Model Metrics
     */
    async getModelMetricsV1AdminMetricsModelsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/models`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get per-model metrics with avg latency and TTFT.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with models list including computed metrics.
     * Get Model Metrics
     */
    async getModelMetricsV1AdminMetricsModelsGet(initOverrides) {
        const response = await this.getModelMetricsV1AdminMetricsModelsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get aggregated overview metrics.  Returns satisfaction rate, generation volume, cost breakdown, failure rate.  `totalGenerations`, `failureRate`, `totalCostUsd`, `avgLatencyMs`, `totalTokensIn`, `totalTokensOut` are computed directly from the real `generations` collection (see `_scan_all_generations`) — NOT from the denormalized `prompts.usageCount` counter this endpoint used before. That counter is only incremented by the legacy /v1 text pipeline (`src.services.generation_service`); the newer /v2 multimodal audio->email pipeline (`src.services.audio_email_generation_service`, around the `buffer_model_increment` call) only bumps the `models` counters and never calls the prompt-side increment — so a prompt-usageCount-based total silently missed every /v2 generation (a live cross-check on 2026-07-25 found 89% of dev\'s real `generations` docs and 34% of prod\'s invisible this way, all sharing `promptId == \"v2-audio-single-call\"`, a value that matches no `prompts` document at all). Root-causing that gap the other way — making the /v2 pipeline also increment prompt-level counters — is a bigger, product- level question (does per-prompt breakdown still make sense for a pipeline that doesn\'t select prompts the same way?) flagged back to pk-v2m rather than silently patched here.  A SECOND live cross-check (same day) found that on prod TODAY, that entire \"invisible pipeline\" slice is 100% synthetic smoke-test/QA bot traffic (`smoke-gen-bot`, `smoke-test-bot`, `qa-agent-dev`) — none of it real customers. Counting the raw `generations` collection would have traded one misleading number (missing real /v2 volume) for another (mixing bot traffic into \"Total Generations\"). So every uid in `src.config.qa_fixture.SYNTHETIC_USER_IDS` (the single source of truth for known synthetic/service-account identities in this repo) is excluded from `totalGenerations`, `failureRate`, and the cost/latency/token sums below — but never silently: the excluded count is always returned as `syntheticGenerationsExcluded`, so the panel can render e.g. \"119 real · 61 synthetic excluded\" instead of an unexplained smaller number.  Only `status == \"completed\"` generation docs carry a meaningful `estimatedCostUsd`/`latencyMs`/`tokensIn`/`tokensOut` (mirrors the convention in `src.utils.metrics.aggregation.compute_daily_buckets`), so those four sums — and `avgLatencyMs`\'s denominator — are over the completed, non-synthetic subset, not `totalGenerations` itself. `failureRate` divides by `totalGenerations` (all non-synthetic statuses), matching what \"failure rate\" implies.  `totalLikes`/`totalDislikes`/`satisfactionRate` are still sourced from the `prompts` collection\'s denormalized counters and inherit the SAME /v2-invisibility gap described above — documented here, not fixed, for the same product-level reason.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     OverviewMetricsResponse.
     * Get Overview Metrics
     */
    async getOverviewMetricsV1AdminMetricsOverviewGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/overview`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OverviewMetricsResponseFromJSON(jsonValue));
    }
    /**
     * Get aggregated overview metrics.  Returns satisfaction rate, generation volume, cost breakdown, failure rate.  `totalGenerations`, `failureRate`, `totalCostUsd`, `avgLatencyMs`, `totalTokensIn`, `totalTokensOut` are computed directly from the real `generations` collection (see `_scan_all_generations`) — NOT from the denormalized `prompts.usageCount` counter this endpoint used before. That counter is only incremented by the legacy /v1 text pipeline (`src.services.generation_service`); the newer /v2 multimodal audio->email pipeline (`src.services.audio_email_generation_service`, around the `buffer_model_increment` call) only bumps the `models` counters and never calls the prompt-side increment — so a prompt-usageCount-based total silently missed every /v2 generation (a live cross-check on 2026-07-25 found 89% of dev\'s real `generations` docs and 34% of prod\'s invisible this way, all sharing `promptId == \"v2-audio-single-call\"`, a value that matches no `prompts` document at all). Root-causing that gap the other way — making the /v2 pipeline also increment prompt-level counters — is a bigger, product- level question (does per-prompt breakdown still make sense for a pipeline that doesn\'t select prompts the same way?) flagged back to pk-v2m rather than silently patched here.  A SECOND live cross-check (same day) found that on prod TODAY, that entire \"invisible pipeline\" slice is 100% synthetic smoke-test/QA bot traffic (`smoke-gen-bot`, `smoke-test-bot`, `qa-agent-dev`) — none of it real customers. Counting the raw `generations` collection would have traded one misleading number (missing real /v2 volume) for another (mixing bot traffic into \"Total Generations\"). So every uid in `src.config.qa_fixture.SYNTHETIC_USER_IDS` (the single source of truth for known synthetic/service-account identities in this repo) is excluded from `totalGenerations`, `failureRate`, and the cost/latency/token sums below — but never silently: the excluded count is always returned as `syntheticGenerationsExcluded`, so the panel can render e.g. \"119 real · 61 synthetic excluded\" instead of an unexplained smaller number.  Only `status == \"completed\"` generation docs carry a meaningful `estimatedCostUsd`/`latencyMs`/`tokensIn`/`tokensOut` (mirrors the convention in `src.utils.metrics.aggregation.compute_daily_buckets`), so those four sums — and `avgLatencyMs`\'s denominator — are over the completed, non-synthetic subset, not `totalGenerations` itself. `failureRate` divides by `totalGenerations` (all non-synthetic statuses), matching what \"failure rate\" implies.  `totalLikes`/`totalDislikes`/`satisfactionRate` are still sourced from the `prompts` collection\'s denormalized counters and inherit the SAME /v2-invisibility gap described above — documented here, not fixed, for the same product-level reason.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     OverviewMetricsResponse.
     * Get Overview Metrics
     */
    async getOverviewMetricsV1AdminMetricsOverviewGet(initOverrides) {
        const response = await this.getOverviewMetricsV1AdminMetricsOverviewGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get per-request cost/context/token stats plus top-N most expensive.  avg/min/max/p95 over completed records in the last `days` days, and the `top` most expensive generations (with userId + contextLength) to surface anomalies — users sending absurdly long context. Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` the same way `get_overview_metrics` does — see `_exclude_synthetic` (a bot doc with an inflated `estimatedCostUsd` would otherwise dominate `topExpensive` and skew `cost.max`/`cost.p95`, this endpoint\'s whole reason to exist).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90).     top: Number of most-expensive generations to return (1..100).  Returns:     dict with sample count, stat summaries, and topExpensive list.
     * Get Per Request Stats
     */
    async getPerRequestStatsV1AdminMetricsPerRequestStatsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        if (requestParameters['top'] != null) {
            queryParameters['top'] = requestParameters['top'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/per-request-stats`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get per-request cost/context/token stats plus top-N most expensive.  avg/min/max/p95 over completed records in the last `days` days, and the `top` most expensive generations (with userId + contextLength) to surface anomalies — users sending absurdly long context. Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` the same way `get_overview_metrics` does — see `_exclude_synthetic` (a bot doc with an inflated `estimatedCostUsd` would otherwise dominate `topExpensive` and skew `cost.max`/`cost.p95`, this endpoint\'s whole reason to exist).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90).     top: Number of most-expensive generations to return (1..100).  Returns:     dict with sample count, stat summaries, and topExpensive list.
     * Get Per Request Stats
     */
    async getPerRequestStatsV1AdminMetricsPerRequestStatsGet(requestParameters = {}, initOverrides) {
        const response = await this.getPerRequestStatsV1AdminMetricsPerRequestStatsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return today\'s plugin-failure counts, total and broken down by stage.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginFailuresSummaryResponse: today\'s date, total count, per-stage     breakdown (zeroed/empty when nothing failed today).
     * Get Plugin Failures Summary
     */
    async getPluginFailuresSummaryV1AdminPluginFailuresSummaryGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/plugin-failures/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PluginFailuresSummaryResponseFromJSON(jsonValue));
    }
    /**
     * Return today\'s plugin-failure counts, total and broken down by stage.  Args:     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginFailuresSummaryResponse: today\'s date, total count, per-stage     breakdown (zeroed/empty when nothing failed today).
     * Get Plugin Failures Summary
     */
    async getPluginFailuresSummaryV1AdminPluginFailuresSummaryGet(initOverrides) {
        const response = await this.getPluginFailuresSummaryV1AdminPluginFailuresSummaryGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get the pre-auth acquisition funnel (V2M-DEV-669, unblocks V2M-DEV-507).  Covers the step BEFORE `get_funnel_metrics`\'s E4 (\"instalacja -> pierwsza generacja\"): `extension_installed` and `content_script_injected` fire before signup, so they have no Firestore record at all — the only place they exist is Plausible (self-hosted, same instance `infra/scripts/plausible-selfhost/plausible-event-readback.sh` in the AgiEu workspace reads from externally). Until this endpoint, this backend had zero Stats-API query wiring (see `src/api/vigil.py`\'s own comment on `plausible_realtime_visitors` for the prior state).  Queried per-brand (`src.config.brand_config.BRANDS`, the same registry `plausible_service._resolve_plausible_domain` already uses for the write side) and summed into `total` — see `PreAuthFunnelResponse` docstring for why an unavailable brand is excluded from the sum rather than zero-filled.  Args:     admin: Admin user info.     days: Window size in whole days, ending now (1..90).  Returns:     PreAuthFunnelResponse.
     * Get Preauth Funnel Metrics
     */
    async getPreauthFunnelMetricsV1AdminMetricsPreauthFunnelGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/preauth-funnel`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PreAuthFunnelResponseFromJSON(jsonValue));
    }
    /**
     * Get the pre-auth acquisition funnel (V2M-DEV-669, unblocks V2M-DEV-507).  Covers the step BEFORE `get_funnel_metrics`\'s E4 (\"instalacja -> pierwsza generacja\"): `extension_installed` and `content_script_injected` fire before signup, so they have no Firestore record at all — the only place they exist is Plausible (self-hosted, same instance `infra/scripts/plausible-selfhost/plausible-event-readback.sh` in the AgiEu workspace reads from externally). Until this endpoint, this backend had zero Stats-API query wiring (see `src/api/vigil.py`\'s own comment on `plausible_realtime_visitors` for the prior state).  Queried per-brand (`src.config.brand_config.BRANDS`, the same registry `plausible_service._resolve_plausible_domain` already uses for the write side) and summed into `total` — see `PreAuthFunnelResponse` docstring for why an unavailable brand is excluded from the sum rather than zero-filled.  Args:     admin: Admin user info.     days: Window size in whole days, ending now (1..90).  Returns:     PreAuthFunnelResponse.
     * Get Preauth Funnel Metrics
     */
    async getPreauthFunnelMetricsV1AdminMetricsPreauthFunnelGet(requestParameters = {}, initOverrides) {
        const response = await this.getPreauthFunnelMetricsV1AdminMetricsPreauthFunnelGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get per-prompt metrics with satisfaction rate and confidence badge.  Confidence badge is \"low\" if total rated < 100.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with prompts list including computed metrics.
     * Get Prompt Metrics
     */
    async getPromptMetricsV1AdminMetricsPromptsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/prompts`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get per-prompt metrics with satisfaction rate and confidence badge.  Confidence badge is \"low\" if total rated < 100.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with prompts list including computed metrics.
     * Get Prompt Metrics
     */
    async getPromptMetricsV1AdminMetricsPromptsGet(initOverrides) {
        const response = await this.getPromptMetricsV1AdminMetricsPromptsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Distinct-user + total-event counts for hitting the quota ceiling (V2M-DEV-012, signal #1).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md`, table row #1, for the full rationale. Reads `quota_exceeded_hits` (`src.services.quota_exceeded_metrics.record_quota_exceeded_hit`), a dedicated first-party collection written from `src.middleware.quota._fire_quota_exceeded` every time a 402 is raised, ALONGSIDE (not instead of) the existing Plausible forward — see that module\'s docstring for why the Plausible aggregate alone cannot give a distinct-user count or a tier breakdown.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 — same \"nieodtwarzalne         wstecz\" framing as M-C.  Returns:     QuotaExceededHitsResponse: days + overall/free/paid distinct-user         and total-event counts, plus the all-time         `hoursSinceLastEventEver` freshness signal.
     * Get Quota Exceeded Hits
     */
    async getQuotaExceededHitsV1AdminMetricsQuotaExceededHitsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/quota-exceeded-hits`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => QuotaExceededHitsResponseFromJSON(jsonValue));
    }
    /**
     * Distinct-user + total-event counts for hitting the quota ceiling (V2M-DEV-012, signal #1).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md`, table row #1, for the full rationale. Reads `quota_exceeded_hits` (`src.services.quota_exceeded_metrics.record_quota_exceeded_hit`), a dedicated first-party collection written from `src.middleware.quota._fire_quota_exceeded` every time a 402 is raised, ALONGSIDE (not instead of) the existing Plausible forward — see that module\'s docstring for why the Plausible aggregate alone cannot give a distinct-user count or a tier breakdown.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 — same \"nieodtwarzalne         wstecz\" framing as M-C.  Returns:     QuotaExceededHitsResponse: days + overall/free/paid distinct-user         and total-event counts, plus the all-time         `hoursSinceLastEventEver` freshness signal.
     * Get Quota Exceeded Hits
     */
    async getQuotaExceededHitsV1AdminMetricsQuotaExceededHitsGet(requestParameters = {}, initOverrides) {
        const response = await this.getQuotaExceededHitsV1AdminMetricsQuotaExceededHitsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get current email quota status.  Args:     admin: Admin user info.     quota_tracker: EmailQuotaTracker.  Returns:     EmailQuotaStatus with today\'s usage and availability.
     * Get Quota
     */
    async getQuotaV1AdminQuotaGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/quota`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => EmailQuotaStatusFromJSON(jsonValue));
    }
    /**
     * Get current email quota status.  Args:     admin: Admin user info.     quota_tracker: EmailQuotaTracker.  Returns:     EmailQuotaStatus with today\'s usage and availability.
     * Get Quota
     */
    async getQuotaV1AdminQuotaGet(initOverrides) {
        const response = await this.getQuotaV1AdminQuotaGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Return recent client_failure_reports, newest-created first.  Args:     limit: Max reports to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ClientFailuresRecentResponse: count + the reports list.
     * Get Recent Client Failures
     */
    async getRecentClientFailuresV1AdminClientFailuresRecentGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/client-failures/recent`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ClientFailuresRecentResponseFromJSON(jsonValue));
    }
    /**
     * Return recent client_failure_reports, newest-created first.  Args:     limit: Max reports to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ClientFailuresRecentResponse: count + the reports list.
     * Get Recent Client Failures
     */
    async getRecentClientFailuresV1AdminClientFailuresRecentGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecentClientFailuresV1AdminClientFailuresRecentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return recent contact_submissions, newest-first.  Args:     limit: Max submissions to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ContactSubmissionsRecentResponse: count + the submissions list.
     * Get Recent Contact Submissions
     */
    async getRecentContactSubmissionsV1AdminContactSubmissionsRecentGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/contact-submissions/recent`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ContactSubmissionsRecentResponseFromJSON(jsonValue));
    }
    /**
     * Return recent contact_submissions, newest-first.  Args:     limit: Max submissions to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     ContactSubmissionsRecentResponse: count + the submissions list.
     * Get Recent Contact Submissions
     */
    async getRecentContactSubmissionsV1AdminContactSubmissionsRecentGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecentContactSubmissionsV1AdminContactSubmissionsRecentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return recent plugin selector-drift buckets, most recently seen first.  Args:     days: Window size in days (1-30, default 7) — filters on `last_seen`.     limit: Max buckets to return (1-500, default 100).     provider: Optional exact-match filter (e.g. \"gmail\").     plugin_version: Optional exact-match filter (e.g. \"1.3.1\").     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginDriftRecentResponse: window size, count, and the events list.
     * Get Recent Plugin Drift
     */
    async getRecentPluginDriftV1AdminPluginDriftRecentGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        if (requestParameters['pluginVersion'] != null) {
            queryParameters['plugin_version'] = requestParameters['pluginVersion'];
        }
        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/plugin-drift/recent`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PluginDriftRecentResponseFromJSON(jsonValue));
    }
    /**
     * Return recent plugin selector-drift buckets, most recently seen first.  Args:     days: Window size in days (1-30, default 7) — filters on `last_seen`.     limit: Max buckets to return (1-500, default 100).     provider: Optional exact-match filter (e.g. \"gmail\").     plugin_version: Optional exact-match filter (e.g. \"1.3.1\").     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginDriftRecentResponse: window size, count, and the events list.
     * Get Recent Plugin Drift
     */
    async getRecentPluginDriftV1AdminPluginDriftRecentGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecentPluginDriftV1AdminPluginDriftRecentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return recent plugin_failure_reports, newest-created first.  Args:     limit: Max reports to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginFailuresRecentResponse: count + the reports list.
     * Get Recent Plugin Failures
     */
    async getRecentPluginFailuresV1AdminPluginFailuresRecentGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/plugin-failures/recent`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PluginFailuresRecentResponseFromJSON(jsonValue));
    }
    /**
     * Return recent plugin_failure_reports, newest-created first.  Args:     limit: Max reports to return (1-100, default 20).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     PluginFailuresRecentResponse: count + the reports list.
     * Get Recent Plugin Failures
     */
    async getRecentPluginFailuresV1AdminPluginFailuresRecentGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecentPluginFailuresV1AdminPluginFailuresRecentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Distinct-user + total-event counts for the hard-cap stop (V2M-DEV-012, M-C).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` §\"M-C. Licznik dobić do twardego limitu\" (+ AMENDMENT 2026-07-31) for the full rationale. Reads `recording_cap_hits` (`src.services.recording_cap_metrics.record_recording_cap_hit`), a dedicated first-party collection written from `POST /v1/analytics/track` (`src.api.analytics._record_recording_cap_hit_if_valid`) every time the plugin\'s recording engine stops a recording because the hard cap fired, NOT the user — see that module\'s docstring for why this needs its own collection instead of the Plausible-forwarded `voice_recording_auto_stopped_cap` event (Plausible is aggregate-only, no per-user model, no property allowlisted for tier).  Two numbers per bucket, never one — the checkpoint names both as load-bearing: `distinctUsers` (\"ilu różnych ludzi w to uderza\") and `totalEvents` (\"ile razy łącznie\") — \"dziesięć dobić jednego zapaleńca to inny sygnał niż jedno dobicie u dziesięciu różnych osób.\" Three buckets — `overall`/`free`/`paid` — split on the `tierBucket` field the CLIENT stamped at write time (resolved from the same `recordingHardCapMsForTier` call that set the timer for that specific recording — never re-derived here from the caller\'s CURRENT tier, which could differ from the tier active when a past recording was made).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (same \"nieodtwarzalne         wstecz\" framing as M-B — meant to be checked daily).  Returns:     RecordingCapHitsResponse: days + overall/free/paid distinct-user and         total-event counts, plus the all-time `hoursSinceLastEventEver`         freshness signal (see that field\'s own docstring).
     * Get Recording Cap Hits
     */
    async getRecordingCapHitsV1AdminMetricsRecordingCapHitsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/recording-cap-hits`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RecordingCapHitsResponseFromJSON(jsonValue));
    }
    /**
     * Distinct-user + total-event counts for the hard-cap stop (V2M-DEV-012, M-C).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` §\"M-C. Licznik dobić do twardego limitu\" (+ AMENDMENT 2026-07-31) for the full rationale. Reads `recording_cap_hits` (`src.services.recording_cap_metrics.record_recording_cap_hit`), a dedicated first-party collection written from `POST /v1/analytics/track` (`src.api.analytics._record_recording_cap_hit_if_valid`) every time the plugin\'s recording engine stops a recording because the hard cap fired, NOT the user — see that module\'s docstring for why this needs its own collection instead of the Plausible-forwarded `voice_recording_auto_stopped_cap` event (Plausible is aggregate-only, no per-user model, no property allowlisted for tier).  Two numbers per bucket, never one — the checkpoint names both as load-bearing: `distinctUsers` (\"ilu różnych ludzi w to uderza\") and `totalEvents` (\"ile razy łącznie\") — \"dziesięć dobić jednego zapaleńca to inny sygnał niż jedno dobicie u dziesięciu różnych osób.\" Three buckets — `overall`/`free`/`paid` — split on the `tierBucket` field the CLIENT stamped at write time (resolved from the same `recordingHardCapMsForTier` call that set the timer for that specific recording — never re-derived here from the caller\'s CURRENT tier, which could differ from the tier active when a past recording was made).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (same \"nieodtwarzalne         wstecz\" framing as M-B — meant to be checked daily).  Returns:     RecordingCapHitsResponse: days + overall/free/paid distinct-user and         total-event counts, plus the all-time `hoursSinceLastEventEver`         freshness signal (see that field\'s own docstring).
     * Get Recording Cap Hits
     */
    async getRecordingCapHitsV1AdminMetricsRecordingCapHitsGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecordingCapHitsV1AdminMetricsRecordingCapHitsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Percentile distribution of recorded voice length in seconds (V2M-DEV-012, M-B).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` §\"M-B. Rozkład długości nagrań — percentyle, NIE średnia\" for the full rationale. p50/p90/p95/p99/max over `GenerationDoc.recordingDurationMs` (`src/api/generate_audio_v2.py`\'s plugin-measured field, already written per-generation — this endpoint is a new READ, not new instrumentation). Deliberately no average field (`compute_percentile_summary`\'s own docstring): the checkpoint\'s own illustration shows a mean hides exactly the tail this metric exists to surface.  Three buckets, split via `_tier_bucket` (reuses the SAME `recording_duration_limit_seconds` that enforces the cap — never a second tier-name list): `overall`, `free` (180s cap), `paid` (300s cap) — per checkpoint AMENDMENT §6 (M-F-R3): \"Dobicie do 180 s przez darmowego (…) i do 300 s przez płacącego (…) to dwa różne sygnały.\" Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` (see `_exclude_synthetic`) and any record with `recordingDurationMs is None` (text-only requests, /v1 records, or an older plugin build that never measured it — `None` is \"not measured\", never coerced to 0).  Deliberate scope boundary, NOT silently glossed over: this endpoint does NOT attempt to derive M-C (\"licznik dobić do twardego limitu\") from `recordingDurationMs >= cap`. The checkpoint explicitly names that exact proxy as misleading — a recording that naturally ends at the cap second is indistinguishable from one the hard-stop truncated, so a distribution right-censored at the cap would report \"nobody wants to record longer\" when the true state could be \"many do, the product just won\'t let them\". The real M-C signal is the client-side \"stopped by limit, not by user\" event fired from the recording engine — see `get_recording_cap_hits` below (V2M-DEV-012, M-C: the Firestore-queryable, per-user version of that event this docstring used to say was left open — it now exists, fed from `frontend/voice2mail_plugin/src/content/hooks/useMediaRecording.ts` via `src.services.recording_cap_metrics`).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (M-B/M-C\'s own         \"nieodtwarzalne wstecz\" framing — this is meant to be checked         daily, not retrospectively).  Returns:     RecordingDurationResponse: days + overall/free/paid percentile buckets.
     * Get Recording Duration Distribution
     */
    async getRecordingDurationDistributionV1AdminMetricsRecordingDurationGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/recording-duration`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RecordingDurationResponseFromJSON(jsonValue));
    }
    /**
     * Percentile distribution of recorded voice length in seconds (V2M-DEV-012, M-B).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` §\"M-B. Rozkład długości nagrań — percentyle, NIE średnia\" for the full rationale. p50/p90/p95/p99/max over `GenerationDoc.recordingDurationMs` (`src/api/generate_audio_v2.py`\'s plugin-measured field, already written per-generation — this endpoint is a new READ, not new instrumentation). Deliberately no average field (`compute_percentile_summary`\'s own docstring): the checkpoint\'s own illustration shows a mean hides exactly the tail this metric exists to surface.  Three buckets, split via `_tier_bucket` (reuses the SAME `recording_duration_limit_seconds` that enforces the cap — never a second tier-name list): `overall`, `free` (180s cap), `paid` (300s cap) — per checkpoint AMENDMENT §6 (M-F-R3): \"Dobicie do 180 s przez darmowego (…) i do 300 s przez płacącego (…) to dwa różne sygnały.\" Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` (see `_exclude_synthetic`) and any record with `recordingDurationMs is None` (text-only requests, /v1 records, or an older plugin build that never measured it — `None` is \"not measured\", never coerced to 0).  Deliberate scope boundary, NOT silently glossed over: this endpoint does NOT attempt to derive M-C (\"licznik dobić do twardego limitu\") from `recordingDurationMs >= cap`. The checkpoint explicitly names that exact proxy as misleading — a recording that naturally ends at the cap second is indistinguishable from one the hard-stop truncated, so a distribution right-censored at the cap would report \"nobody wants to record longer\" when the true state could be \"many do, the product just won\'t let them\". The real M-C signal is the client-side \"stopped by limit, not by user\" event fired from the recording engine — see `get_recording_cap_hits` below (V2M-DEV-012, M-C: the Firestore-queryable, per-user version of that event this docstring used to say was left open — it now exists, fed from `frontend/voice2mail_plugin/src/content/hooks/useMediaRecording.ts` via `src.services.recording_cap_metrics`).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (M-B/M-C\'s own         \"nieodtwarzalne wstecz\" framing — this is meant to be checked         daily, not retrospectively).  Returns:     RecordingDurationResponse: days + overall/free/paid percentile buckets.
     * Get Recording Duration Distribution
     */
    async getRecordingDurationDistributionV1AdminMetricsRecordingDurationGet(requestParameters = {}, initOverrides) {
        const response = await this.getRecordingDurationDistributionV1AdminMetricsRecordingDurationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Completed/failed counts and success rate per plugin version (V2M-DEV-012, signal #12).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` signal #12 (\"Wyciek darmowych generacji + success rate per wersja\") — the leak- snapshot half already exists (`src.db.models.user.User.lazy_quota_reset`\'s `write_usage_snapshot` call); this is the other half, previously unbuilt despite the underlying data (`GenerationDoc.pluginVersion`, set from the `X-Plugin-Version` request header in `src/api/generate_audio_v2.py`) already being written per-generation — a new READ, not new instrumentation, same shape as `get_recording_duration_distribution`\'s own docstring note about M-B.  See `compute_success_rate_by_version` for the full aggregation contract (unknown-version bucketing, what counts toward `total`).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (same \"nieodtwarzalne         wstecz\" framing as M-B/M-C — a version\'s rollout health is meant         to be checked daily, not retrospectively).  Returns:     SuccessRateByVersionResponse: days + per-version breakdown, plus the         all-time `hoursSinceLastEventEver` freshness signal (see that         field\'s own docstring).
     * Get Success Rate By Version
     */
    async getSuccessRateByVersionV1AdminMetricsSuccessRateByVersionGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/success-rate-by-version`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessRateByVersionResponseFromJSON(jsonValue));
    }
    /**
     * Completed/failed counts and success rate per plugin version (V2M-DEV-012, signal #12).  See checkpoint `2026-07-25-v2m-projekt-metryk-12-sygnalow.md` signal #12 (\"Wyciek darmowych generacji + success rate per wersja\") — the leak- snapshot half already exists (`src.db.models.user.User.lazy_quota_reset`\'s `write_usage_snapshot` call); this is the other half, previously unbuilt despite the underlying data (`GenerationDoc.pluginVersion`, set from the `X-Plugin-Version` request header in `src/api/generate_audio_v2.py`) already being written per-generation — a new READ, not new instrumentation, same shape as `get_recording_duration_distribution`\'s own docstring note about M-B.  See `compute_success_rate_by_version` for the full aggregation contract (unknown-version bucketing, what counts toward `total`).  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), default 1 (same \"nieodtwarzalne         wstecz\" framing as M-B/M-C — a version\'s rollout health is meant         to be checked daily, not retrospectively).  Returns:     SuccessRateByVersionResponse: days + per-version breakdown, plus the         all-time `hoursSinceLastEventEver` freshness signal (see that         field\'s own docstring).
     * Get Success Rate By Version
     */
    async getSuccessRateByVersionV1AdminMetricsSuccessRateByVersionGet(requestParameters = {}, initOverrides) {
        const response = await this.getSuccessRateByVersionV1AdminMetricsSuccessRateByVersionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get daily time-series of generations, tokens, and cost.  Scans completed generation records in the last `days` days and buckets them by UTC day. Each bucket sums generations, tokensIn, tokensOut, cost. Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` (bot/smoke-test traffic) the same way `get_overview_metrics` does — see `_exclude_synthetic`.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90).  Returns:     dict with days and a list of daily buckets (ascending by date).
     * Get Timeseries Metrics
     */
    async getTimeseriesMetricsV1AdminMetricsTimeseriesGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/timeseries`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get daily time-series of generations, tokens, and cost.  Scans completed generation records in the last `days` days and buckets them by UTC day. Each bucket sums generations, tokensIn, tokensOut, cost. Excludes `src.config.qa_fixture.SYNTHETIC_USER_IDS` (bot/smoke-test traffic) the same way `get_overview_metrics` does — see `_exclude_synthetic`.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90).  Returns:     dict with days and a list of daily buckets (ascending by date).
     * Get Timeseries Metrics
     */
    async getTimeseriesMetricsV1AdminMetricsTimeseriesGet(requestParameters = {}, initOverrides) {
        const response = await this.getTimeseriesMetricsV1AdminMetricsTimeseriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get per-customer unit economics: top spenders, cost-by-tier, free-tier burn.  Reads daily_user_metrics/{day}_{uid} (src.services.unit_economics_service), the per-customer attribution both generation pipelines (/v1 and /v2) write alongside the existing per-tier daily_metrics/{day} aggregate. Answers PK\'s 2026-07-24 unit-economics directive: exact per-customer Gemini spend, for the free-vs-paid balance and pricing-migration decision.  `estimatedRevenuePln` on each tier bucket is a LIST-PRICE APPROXIMATION (see src.services.unit_economics_service.estimate_tier_revenue_pln docstring) — not reconciled Stripe revenue, and PLN against a USD `costUsd` with no FX conversion. Good for an order-of-magnitude sanity check only.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), ending today (UTC), default 1.     top: Number of highest-cost users to return (1..200), default 20.  Returns:     UnitEconomicsResponse: including the all-time `hoursSinceLastEventEver`         freshness signal (see that field\'s own docstring).
     * Get Unit Economics
     */
    async getUnitEconomicsV1AdminMetricsUnitEconomicsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['days'] != null) {
            queryParameters['days'] = requestParameters['days'];
        }
        if (requestParameters['top'] != null) {
            queryParameters['top'] = requestParameters['top'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/metrics/unit-economics`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => UnitEconomicsResponseFromJSON(jsonValue));
    }
    /**
     * Get per-customer unit economics: top spenders, cost-by-tier, free-tier burn.  Reads daily_user_metrics/{day}_{uid} (src.services.unit_economics_service), the per-customer attribution both generation pipelines (/v1 and /v2) write alongside the existing per-tier daily_metrics/{day} aggregate. Answers PK\'s 2026-07-24 unit-economics directive: exact per-customer Gemini spend, for the free-vs-paid balance and pricing-migration decision.  `estimatedRevenuePln` on each tier bucket is a LIST-PRICE APPROXIMATION (see src.services.unit_economics_service.estimate_tier_revenue_pln docstring) — not reconciled Stripe revenue, and PLN against a USD `costUsd` with no FX conversion. Good for an order-of-magnitude sanity check only.  Args:     admin: Admin user info.     db: Firestore client.     days: Window size in days (1..90), ending today (UTC), default 1.     top: Number of highest-cost users to return (1..200), default 20.  Returns:     UnitEconomicsResponse: including the all-time `hoursSinceLastEventEver`         freshness signal (see that field\'s own docstring).
     * Get Unit Economics
     */
    async getUnitEconomicsV1AdminMetricsUnitEconomicsGet(requestParameters = {}, initOverrides) {
        const response = await this.getUnitEconomicsV1AdminMetricsUnitEconomicsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get full user details for admin view.  Args:     uid: User UID.     admin: Admin user info.     db: Firestore client.  Returns:     Full user data.
     * Get User Details
     */
    async getUserDetailsV1AdminUsersUidGetRaw(requestParameters, initOverrides) {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError('uid', 'Required parameter "uid" was null or undefined when calling getUserDetailsV1AdminUsersUidGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/users/{uid}`;
        urlPath = urlPath.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters['uid'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get full user details for admin view.  Args:     uid: User UID.     admin: Admin user info.     db: Firestore client.  Returns:     Full user data.
     * Get User Details
     */
    async getUserDetailsV1AdminUsersUidGet(requestParameters, initOverrides) {
        const response = await this.getUserDetailsV1AdminUsersUidGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gift generations to a user.  Args:     uid: User UID.     request: Gift details (amount and type).     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status.
     * Gift Generations
     */
    async giftGenerationsV1AdminUsersUidGiftPostRaw(requestParameters, initOverrides) {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError('uid', 'Required parameter "uid" was null or undefined when calling giftGenerationsV1AdminUsersUidGiftPost().');
        }
        if (requestParameters['giftRequest'] == null) {
            throw new runtime.RequiredError('giftRequest', 'Required parameter "giftRequest" was null or undefined when calling giftGenerationsV1AdminUsersUidGiftPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/users/{uid}/gift`;
        urlPath = urlPath.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters['uid'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GiftRequestToJSON(requestParameters['giftRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Gift generations to a user.  Args:     uid: User UID.     request: Gift details (amount and type).     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     dict with status.
     * Gift Generations
     */
    async giftGenerationsV1AdminUsersUidGiftPost(requestParameters, initOverrides) {
        const response = await this.giftGenerationsV1AdminUsersUidGiftPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all campaigns.  Args:     admin: Admin user info.     service: EmailCampaignService.  Returns:     CampaignListResponse with all campaigns.
     * List Campaigns
     */
    async listCampaignsV1AdminCampaignsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignListResponseFromJSON(jsonValue));
    }
    /**
     * List all campaigns.  Args:     admin: Admin user info.     service: EmailCampaignService.  Returns:     CampaignListResponse with all campaigns.
     * List Campaigns
     */
    async listCampaignsV1AdminCampaignsGet(initOverrides) {
        const response = await this.listCampaignsV1AdminCampaignsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * List mail_triage records, newest-triaged first.  Args:     category: Optional exact-match filter on category.     urgency: Optional exact-match filter on urgency.     limit: Max records per page (1-200, default 50).     cursor: Opaque pagination cursor (previous page\'s next_cursor).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     MailTriageListResponse: page of records + next_cursor (None on last page).
     * List Mail Triage Records
     */
    async listMailTriageRecordsV1AdminMailTriageGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }
        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        if (requestParameters['urgency'] != null) {
            queryParameters['urgency'] = requestParameters['urgency'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/mail-triage`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => MailTriageListResponseFromJSON(jsonValue));
    }
    /**
     * List mail_triage records, newest-triaged first.  Args:     category: Optional exact-match filter on category.     urgency: Optional exact-match filter on urgency.     limit: Max records per page (1-200, default 50).     cursor: Opaque pagination cursor (previous page\'s next_cursor).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     MailTriageListResponse: page of records + next_cursor (None on last page).
     * List Mail Triage Records
     */
    async listMailTriageRecordsV1AdminMailTriageGet(requestParameters = {}, initOverrides) {
        const response = await this.listMailTriageRecordsV1AdminMailTriageGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all models with performance metrics.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with models list.
     * List Models
     */
    async listModelsV1AdminModelsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/models`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * List all models with performance metrics.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with models list.
     * List Models
     */
    async listModelsV1AdminModelsGet(initOverrides) {
        const response = await this.listModelsV1AdminModelsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all prompts with metrics.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with prompts list.
     * List Prompts
     */
    async listPromptsV1AdminPromptsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/prompts`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * List all prompts with metrics.  Args:     admin: Admin user info.     db: Firestore client.  Returns:     dict with prompts list.
     * List Prompts
     */
    async listPromptsV1AdminPromptsGet(initOverrides) {
        const response = await this.listPromptsV1AdminPromptsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Return the most recent visits (created_at desc), PII-scrubbed.  Only non-sensitive fields are returned: a truncated visit_token, UTM params, click-id PRESENCE booleans (never raw ids), landing_url, welcome_at, and created_at. ip_plain, user_agent, fbc, fbp, and raw click ids are never included in the response.  Args:     limit: Max visits to return (1-200, default 50).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     RecentVisitsResponse: The most recent visits, newest first.
     * List Recent Visits
     */
    async listRecentVisitsV1AdminAttributionVisitsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/attribution/visits`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => RecentVisitsResponseFromJSON(jsonValue));
    }
    /**
     * Return the most recent visits (created_at desc), PII-scrubbed.  Only non-sensitive fields are returned: a truncated visit_token, UTM params, click-id PRESENCE booleans (never raw ids), landing_url, welcome_at, and created_at. ip_plain, user_agent, fbc, fbp, and raw click ids are never included in the response.  Args:     limit: Max visits to return (1-200, default 50).     admin: Admin user info (viewer or admin role).     db: Firestore client.  Returns:     RecentVisitsResponse: The most recent visits, newest first.
     * List Recent Visits
     */
    async listRecentVisitsV1AdminAttributionVisitsGet(requestParameters = {}, initOverrides) {
        const response = await this.listRecentVisitsV1AdminAttributionVisitsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List users with cursor pagination.  Returns a page of users ordered by email with the summary fields the admin Users table requires: uid, email, tier, registeredAt (account-creation timestamp), billingInterval (subscription cycle for paid tiers, null for free), and generationCount. Cursor is the email of the last user in the previous page; pass it back as-is to fetch the next page.  Args:     limit: Max users per page (1-100, default 20).     cursor: Email cursor for pagination (exclusive start-after).     _admin: Admin user info (viewer or admin role, triggers auth gate).     db: Firestore client.  Returns:     dict with ``users`` list and ``nextCursor``.
     * List Users
     */
    async listUsersV1AdminUsersGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/users`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * List users with cursor pagination.  Returns a page of users ordered by email with the summary fields the admin Users table requires: uid, email, tier, registeredAt (account-creation timestamp), billingInterval (subscription cycle for paid tiers, null for free), and generationCount. Cursor is the email of the last user in the previous page; pass it back as-is to fetch the next page.  Args:     limit: Max users per page (1-100, default 20).     cursor: Email cursor for pagination (exclusive start-after).     _admin: Admin user info (viewer or admin role, triggers auth gate).     db: Firestore client.  Returns:     dict with ``users`` list and ``nextCursor``.
     * List Users
     */
    async listUsersV1AdminUsersGet(requestParameters = {}, initOverrides) {
        const response = await this.listUsersV1AdminUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Re-run the billing-pipeline health check on demand and return fresh results.  Identical bounded read-only work to the GET endpoint and the scheduled job; exposed as POST so the panel\'s \"Refresh\" button reads as an explicit action. Does not email.  Args:     _admin: Admin user info (viewer or admin).     db: Firestore client.  Returns:     dict with checkedAt, healthy, the metrics, and any alerts.
     * Refresh Billing Observability
     */
    async refreshBillingObservabilityV1AdminBillingObservabilityRefreshPostRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/billing/observability/refresh`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Re-run the billing-pipeline health check on demand and return fresh results.  Identical bounded read-only work to the GET endpoint and the scheduled job; exposed as POST so the panel\'s \"Refresh\" button reads as an explicit action. Does not email.  Args:     _admin: Admin user info (viewer or admin).     db: Firestore client.  Returns:     dict with checkedAt, healthy, the metrics, and any alerts.
     * Refresh Billing Observability
     */
    async refreshBillingObservabilityV1AdminBillingObservabilityRefreshPost(initOverrides) {
        const response = await this.refreshBillingObservabilityV1AdminBillingObservabilityRefreshPostRaw(initOverrides);
        return await response.value();
    }
    /**
     * Search users by email prefix.  Args:     email: Email prefix to search.     admin: Admin user info.     db: Firestore client.  Returns:     dict with users list.
     * Search Users
     */
    async searchUsersV1AdminUsersSearchGetRaw(requestParameters, initOverrides) {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling searchUsersV1AdminUsersSearchGet().');
        }
        const queryParameters = {};
        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/users/search`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Search users by email prefix.  Args:     email: Email prefix to search.     admin: Admin user info.     db: Firestore client.  Returns:     dict with users list.
     * Search Users
     */
    async searchUsersV1AdminUsersSearchGet(requestParameters, initOverrides) {
        const response = await this.searchUsersV1AdminUsersSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send test emails for a campaign.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     SendTestResponse with per-recipient test results.  Raises:     HTTPException: 404 if campaign not found.
     * Send Test
     */
    async sendTestV1AdminCampaignsCampaignIdTestPostRaw(requestParameters, initOverrides) {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError('campaignId', 'Required parameter "campaignId" was null or undefined when calling sendTestV1AdminCampaignsCampaignIdTestPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/campaigns/{campaign_id}/test`;
        urlPath = urlPath.replace(`{${"campaign_id"}}`, encodeURIComponent(String(requestParameters['campaignId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SendTestResponseFromJSON(jsonValue));
    }
    /**
     * Send test emails for a campaign.  Args:     campaign_id: Campaign document ID.     admin: Admin user info (requires admin role).     service: EmailCampaignService.  Returns:     SendTestResponse with per-recipient test results.  Raises:     HTTPException: 404 if campaign not found.
     * Send Test
     */
    async sendTestV1AdminCampaignsCampaignIdTestPost(requestParameters, initOverrides) {
        const response = await this.sendTestV1AdminCampaignsCampaignIdTestPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update a prompt — increments version, preserves alpha/beta.  Args:     prompt_id: Prompt document ID.     request: Fields to update.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     Updated prompt data.
     * Update Prompt
     */
    async updatePromptV1AdminPromptsPromptIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters['promptId'] == null) {
            throw new runtime.RequiredError('promptId', 'Required parameter "promptId" was null or undefined when calling updatePromptV1AdminPromptsPromptIdPatch().');
        }
        if (requestParameters['updatePromptRequest'] == null) {
            throw new runtime.RequiredError('updatePromptRequest', 'Required parameter "updatePromptRequest" was null or undefined when calling updatePromptV1AdminPromptsPromptIdPatch().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/admin/prompts/{prompt_id}`;
        urlPath = urlPath.replace(`{${"prompt_id"}}`, encodeURIComponent(String(requestParameters['promptId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePromptRequestToJSON(requestParameters['updatePromptRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Update a prompt — increments version, preserves alpha/beta.  Args:     prompt_id: Prompt document ID.     request: Fields to update.     admin: Admin user info (requires admin role).     db: Firestore client.  Returns:     Updated prompt data.
     * Update Prompt
     */
    async updatePromptV1AdminPromptsPromptIdPatch(requestParameters, initOverrides) {
        const response = await this.updatePromptV1AdminPromptsPromptIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListMailTriageRecordsV1AdminMailTriageGetUrgencyEnum = {
    ignore: 'ignore',
    normal: 'normal',
    urgent: 'urgent'
};
